import { Route, type RouteObject } from "react-router";

export const transferRoutesToComponent = (router: RouteObject[]) => {
	return router.map((route, index) =>
		!route.children ? (
			<Route
				key={`${route.path}-${index}`}
				path={route.path}
				element={route.element}
			/>
		) : (
			<Route
				key={`${route.path}-${index}`}
				path={route.path}
				element={route.element}
			>
				{Array.isArray(route.children) &&
					transferRoutesToComponent(route.children)}
			</Route>
		),
	);
};
